"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrompt = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function usePrompt() {
    const [prompts, setPrompts] = react_1.useState([]);
    const [loading, setLoading] = react_1.useState(false);
    // left here to test if unregister works correctly
    // console.log(prompts);
    const [prompt, setPrompt] = react_1.useState();
    const dialogRef = react_1.useRef(null);
    const submitCallbackRef = react_1.useRef();
    const closeCallbackRef = react_1.useRef();
    const testPrompt = event_callback_hook_1.useEventCallback(({ key, submitCallback, closeCallback = lodash_1.noop, }) => {
        var _a;
        const prompt = prompts.find((p) => p.key === key);
        if (prompt) {
            setPrompt(prompt);
            submitCallbackRef.current = submitCallback;
            closeCallbackRef.current = closeCallback;
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
        }
        else {
            submitCallback(undefined);
        }
    });
    const registerPrompts = event_callback_hook_1.useEventCallback((prompts) => {
        setPrompts((current) => [...current, ...prompts]);
    });
    const unregisterPrompts = event_callback_hook_1.useEventCallback((prompts) => {
        var _a;
        setPrompts((current) => current.filter((p) => !prompts.includes(p)));
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.close();
    });
    const promptConfirm = event_callback_hook_1.useEventCallback(async (values, formRef) => {
        try {
            setLoading(true);
            const callback = submitCallbackRef.current;
            let result = callback(values, formRef);
            if (result instanceof Promise) {
                result = await result;
            }
            if (result !== true) {
                submitCallbackRef.current = undefined;
                closeCallbackRef.current = undefined;
                prompts.forEach((prompt) => prompt.clearCallback !== undefined && prompt.clearCallback());
            }
            setLoading(false);
            return result;
        }
        catch (err) {
            console.log(err);
            setLoading(false);
        }
    });
    const promptCancel = event_callback_hook_1.useEventCallback(() => {
        const callback = closeCallbackRef.current;
        callback();
        setLoading(false);
        submitCallbackRef.current = undefined;
        closeCallbackRef.current = undefined;
    });
    const context = react_1.useMemo(() => ({
        testPrompt,
        registerPrompts,
        unregisterPrompts,
    }), [testPrompt, registerPrompts, unregisterPrompts]);
    return { context, dialogRef, prompt, promptConfirm, promptCancel, loading };
}
exports.usePrompt = usePrompt;
//# sourceMappingURL=prompt-hook.js.map